// extracted by mini-css-extract-plugin
export var container = "_9a-0";
export var icon = "_9a-1";
export var text = "_9a-2";